import { useEffect, useRef } from "react";
import { HttpTransportType, HubConnection } from "@microsoft/signalr";
import { SetUpSignalRConnection } from "./SignalRConnection";

export interface FrBulkFetchStatusPayload {
  year: number;
  month: number;
  status: number;
  statusText: string;
  errorMessage: string | null;
}

export const useFrBulkFetchStatusListener = (
  accessToken: string,
  onStatusChanged: (payload: FrBulkFetchStatusPayload) => void
): void => {
  const connectionRef = useRef<HubConnection | null>(null);

  useEffect(() => {
    if (!accessToken) return;

    let isMounted = true;

    SetUpSignalRConnection("hub/eventhub", HttpTransportType.WebSockets, accessToken).then(connection => {
      if (!isMounted) {
        connection.stop();
        return;
      }
      connectionRef.current = connection;

      connection.on("FrBulkFetchStatusChanged", (payload: FrBulkFetchStatusPayload) => {
        onStatusChanged(payload);
      });

      connection.onclose(() => {
        // connection closed
      });
    });

    return () => {
      isMounted = false;
      connectionRef.current?.stop();
      connectionRef.current = null;
    };
  }, [accessToken]); // eslint-disable-line react-hooks/exhaustive-deps
};
